import { Currency } from './actionsFactory';

/**
 * Default currencies to use as fallback when API fails
 */
const defaultCurrencies: Currency[] = [
  {
    code: 'EUR',
    name: 'Euro',
    symbol: '€',
    symbol_native: '€',
    countryCode: 'NL',
  },
  {
    code: 'USD',
    name: 'US Dollar',
    symbol: '$',
    symbol_native: '$',
    countryCode: 'US',
  },
  {
    code: 'GBP',
    name: 'British Pound',
    symbol: '£',
    symbol_native: '£',
    countryCode: 'GB',
  },
];

export default defaultCurrencies;
